import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["checkbox"]
    static values = {
        shelfData: Object
    }

    connect() {
        // Initialize selected shelves from pre-checked boxes
        this.selectedShelves = new Set(
            this.checkboxTargets
                .filter(checkbox => checkbox.checked)
                .map(checkbox => parseInt(checkbox.value))
        )
    }

    toggle(event) {
        const checkbox = event.target
        const shelfId = parseInt(checkbox.value)
        const shelfType = checkbox.dataset.shelfType

        if (checkbox.checked) {
            this.selectedShelves.add(shelfId)
            this.handleMutualExclusion(shelfType)
        } else {
            this.selectedShelves.delete(shelfId)
        }
    }

    handleMutualExclusion(selectedType) {
        const shelfData = this.shelfDataValue

        // Define which types to uncheck based on the selected type. These rules
        // are also enforced server-side (Shelf::MUTUALLY_EXCLUSIVE_SHELF_TYPES);
        // keep the two in sync. This client copy is just for instant feedback.
        let typesToUncheck = []
        if (selectedType === 'owned') {
            typesToUncheck = ['wishlist']
        } else if (selectedType === 'liked') {
            typesToUncheck = ['disliked', 'wishlist']
        } else if (selectedType === 'disliked') {
            typesToUncheck = ['liked', 'wishlist']
        } else if (selectedType === 'wishlist') {
            typesToUncheck = ['owned', 'liked', 'disliked']
        }

        // Uncheck incompatible shelves
        this.checkboxTargets.forEach(checkbox => {
            const type = checkbox.dataset.shelfType
            if (typesToUncheck.includes(type)) {
                checkbox.checked = false
                this.selectedShelves.delete(parseInt(checkbox.value))
            }
        })
    }
} 